import { render, staticRenderFns } from "./cumulative.vue?vue&type=template&id=5c21e101&scoped=true"
import script from "./cumulative.vue?vue&type=script&lang=js"
export * from "./cumulative.vue?vue&type=script&lang=js"
import style0 from "./cumulative.vue?vue&type=style&index=0&id=5c21e101&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21e101",
  null
  
)

export default component.exports